import Card from "@mui/material/Card";
import Stack from "@mui/material/Stack";
import { Theme } from "../data/style/Theme";
import Snackbar from "@mui/material/Snackbar";
import { MainText } from "../data/style/Style";
import { createContext, useContext, useState } from "react";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import useScreenSize from "./ScreenContext";

const NotificationContext = createContext();

const NotificationIcon = ({ type }) => {
  return (
    <>
      {type === "success" ? (
        <CheckCircleOutlineIcon sx={{ color: Theme.palette.text }} />
      ) : type === "error" ? (
        <HighlightOffIcon sx={{ color: Theme.palette.text }} />
      ) : (
        <ErrorOutlineIcon sx={{ color: Theme.palette.text }} />
      )}
    </>
  );
};

export const NotificationProvider = ({ children }) => {
  const { mobileDevice } = useScreenSize();
  const [type, setType] = useState("");
  const [openNotification, setOpenNotification] = useState(false);
  const [notificationText, setNotificationText] = useState("");

  const errorClass = {
    background: Theme.palette.down,
    padding: "7px",
    width: mobileDevice ? "100%" : "300px",
    borderRadius: 4,
  };

  const successClass = {
    background: Theme.palette.up,
    padding: "7px",
    width: mobileDevice ? "100%" : "300px",
    borderRadius: 4,
  };

  const infoClass = {
    background: Theme.palette.blue,
    padding: "7px",
    borderRadius: 4,
    width: mobileDevice ? "100%" : "300px",
  };

  const [styling, setStyling] = useState(infoClass);

  const enableNotification = (text, type) => {
    setType(type);

    if (type === "error") {
      setStyling(errorClass);
    } else if (type === "success") {
      setStyling(successClass);
    } else {
      setStyling(infoClass);
    }
    setNotificationText(text);
    setOpenNotification(true);
  };

  const handleClose = () => setOpenNotification(false);

  let contextData = {
    enableNotification,
  };

  return (
    <NotificationContext.Provider value={contextData}>
      {children}
      <Snackbar
        open={openNotification}
        autoHideDuration={3000}
        onClose={handleClose}
      >
        <Card elevation={10} sx={styling}>
          <Stack direction={"row"} gap={2} alignItems={"center"}>
            <NotificationIcon type={type} />
            <MainText>{notificationText}</MainText>
          </Stack>
        </Card>
      </Snackbar>
    </NotificationContext.Provider>
  );
};

export const useNotifications = () => {
  return useContext(NotificationContext);
};
